var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocs = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2.5h1.268c1.53 0 3.05.226 4.513.672L8 3.39l.72-.218a15.5 15.5 0 0 1 4.512-.672H14.5v10.587h-1.268a14.5 14.5 0 0 0-4.222.628L8 14.023l-1.01-.308a14.5 14.5 0 0 0-4.222-.628H1.5V2.5Zm1 1v8.587h.268c1.53 0 3.05.226 4.513.671l.219.067V4.284l-.51-.156A14.5 14.5 0 0 0 2.768 3.5H2.5Zm6 .784v8.541l.22-.066a15.501 15.501 0 0 1 4.512-.672h.268V3.5h-.268a14.5 14.5 0 0 0-4.222.628l-.51.156Z",
    fill: "#9999AC"
  })));
};
export default SvgDocs;